const API_ENDPOINTS = {
  // NOTE Auth::
  // ADD_USER_BY_REGISTRATION: "/api/user/auth/register",
  // GET_EMAIL_VERIFY: "/api/user/auth/verify-email",
  // RESEND_OTP: "/api/user/auth/resend-otp",
  // FORGOT_PASSWORD: "/api/user/auth/forgot-password",
  // RESET_PASSWORD: "/api/user/auth/reset-password",
  LOGOUT_USER: "/api/user/auth/logout",

  // NOTE Session::
  GET_SESSION_USER_DETAILS: "/api/session-details",

  // NOTE Profile::
  UPDATE_PROFILE: "/api/profile/update",

  // Media Management::
  // PHOTO
  CREATE_NEW_PHOTO: "/api/media/photo/create",
  GET_ALL_PHOTOS: "/api/media/photo/view",
  GET_PHOTO_DETAILS: "/api/media/photo/details",
  UPDATE_PHOTO: "/api/media/photo/update",
  DELETE_PHOTO: "/api/media/photo/delete",
  TOGGLE_PHOTO_ACTIVE_STATUS: "/api/media/photo/toggle-active-status",
  TOGGLE_PHOTO_FEATURED_STATUS: "/api/media/photo/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_PHOTOS: "/api/client/media/photo/list",

  // VIDEO
  CREATE_NEW_VIDEO: "/api/media/video/create",
  GET_ALL_VIDEOS: "/api/media/video/view",
  GET_VIDEO_DETAILS: "/api/media/video/details",
  UPDATE_VIDEO: "/api/media/video/update",
  DELETE_VIDEO: "/api/media/video/delete",
  TOGGLE_VIDEO_ACTIVE_STATUS: "/api/media/video/toggle-active-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_VIDEOS: "/api/client/media/video/list",

  // MOVIE
  CREATE_NEW_MOVIE: "/api/media/movie/create",
  GET_ALL_MOVIES: "/api/media/movie/view",
  GET_MOVIE_DETAILS: "/api/media/movie/details",
  UPDATE_MOVIE: "/api/media/movie/update",
  DELETE_MOVIE: "/api/media/movie/delete",
  TOGGLE_MOVIE_ACTIVE_STATUS: "/api/media/movie/toggle-active-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_MOVIES: "/api/client/media/movie/list",

  // Search Results::
  GET_ALL_SEARCH_RESULTS: "/api/client/search-result",

  // FAQ Management::
  // <> ADMIN <>
  CREATE_NEW_FAQ: "/api/faq/management/create",
  GET_ALL_FAQS: "/api/faq/management/view",
  GET_FAQ_DETAILS: "/api/faq/management/details",
  UPDATE_FAQ: "/api/faq/management/update",
  DELETE_FAQ: "/api/faq/management/delete",
  TOGGLE_FAQ_ACTIVE_STATUS: "/api/faq/management/toggle-active-status",
  TOGGLE_FAQ_FEATURED_STATUS: "/api/faq/management/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_FAQS: "/api/client/faq",
  GET_ALL_PUBLIC_FAQ_CATEGORIES: "/api/client/faq/category",

  // FAQ Category::
  // <> ADMIN <>
  CREATE_NEW_FAQ_CATEGORY: "/api/faq/category/create",
  GET_ALL_FAQ_CATEGORIES: "/api/faq/category/view",
  GET_FAQ_CATEGORY_DETAILS: "/api/faq/category/details",
  UPDATE_FAQ_CATEGORY: "/api/faq/category/update",
  DELETE_FAQ_CATEGORY: "/api/faq/category/delete",
  TOGGLE_FAQ_CATEGORY_ACTIVE_STATUS: "/api/faq/category/toggle-active-status",
  TOGGLE_FAQ_CATEGORY_DEFAULT_STATUS: "/api/faq/category/toggle-default-status",
  // <> PUBLIC <>

  // News Article::
  // <> ADMIN <>
  CREATE_NEW_NEWS_ARTICLE: "/api/news/article/create",
  GET_ALL_NEWS_ARTICLES: "/api/news/article/view",
  GET_NEWS_ARTICLE_DETAILS: "/api/news/article/details",
  UPDATE_NEWS_ARTICLE: "/api/news/article/update",
  DELETE_NEWS_ARTICLE: "/api/news/article/delete",
  TOGGLE_NEWS_ARTICLE_ACTIVE_STATUS: "/api/news/article/toggle-active-status",
  TOGGLE_NEWS_ARTICLE_FEATURED_STATUS:
    "/api/news/article/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_NEWS_ARTICLES: "/api/client/news/article/list",
  GET_PUBLIC_NEWS_ARTICLE_DETAILS: "/api/client/news/article/details",

  // NOTE News Category::
  // <> ADMIN <>
  CREATE_NEW_NEWS_CATEGORY: "/api/news/category/create",
  GET_ALL_NEWS_CATEGORIES: "/api/news/category/view",
  GET_NEWS_CATEGORY_DETAILS: "/api/news/category/details",
  UPDATE_NEWS_CATEGORY: "/api/news/category/update",
  TOGGLE_NEWS_CATEGORY_ACTIVE_STATUS: "/api/news/category/toggle-active-status",
  TOGGLE_NEWS_CATEGORY_FEATURED_STATUS:
    "/api/news/category/toggle-featured-status",
  TOGGLE_NEWS_CATEGORY_DEFAULT_STATUS:
    "/api/news/category/toggle-default-status",
  DELETE_NEWS_CATEGORY: "/api/news/category/delete",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_NEWS_CATEGORIES: "/api/client/news/category/list",

  // NOTE Contact::
  // <> ADMIN <>
  CREATE_NEW_CONTACT: "/api/contact/create",
  GET_ALL_CONTACTS: "/api/contact/view",
  GET_ALL_CONTACT_QUERIES: "/api/contact/queries",
  GET_CONTACT_DETAILS: "/api/contact/details",
  UPDATE_CONTACT: "/api/contact/update",
  DELETE_CONTACT: "/api/contact/delete",
  DELETE_CONTACT_QUERY: "/api/contact/queries/delete",
  TOGGLE_CONTACT_ACTIVE_STATUS: "/api/contact/toggle-active-status",
  TOGGLE_CONTACT_ACTIVE_FORM_STATUS: "/api/contact/toggle-active-form-status",
  TOGGLE_CONTACT_FEATURED_STATUS: "/api/contact/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_CONTACTS: "/api/client/contact/list",
  GET_PUBLIC_CONTACT_DETAILS: "/api/client/contact/details",
  SUBMIT_CONTACT_QUERY: "/api/client/contact/query",

  // NOTE Testimonial::
  // <> ADMIN <>
  CREATE_NEW_TESTIMONIAL: "/api/testimonial/create",
  GET_ALL_TESTIMONIALS: "/api/testimonial/view",
  GET_TESTIMONIAL_DETAILS: "/api/testimonial/details",
  UPDATE_TESTIMONIAL: "/api/testimonial/update",
  DELETE_TESTIMONIAL: "/api/testimonial/delete",
  TOGGLE_TESTIMONIAL_ACTIVE_STATUS: "/api/testimonial/toggle-active-status",
  TOGGLE_TESTIMONIAL_FEATURED_STATUS: "/api/testimonial/toggle-featured-status",
  // <>PUBLIC<>
  GET_ALL_PUBLIC_TESTIMONIALS: "/api/client/testimonial/list",

  // NOTE Career::
  // <> ADMIN <>
  CREATE_NEW_CAREER: "/api/career/create",
  GET_ALL_CAREERS: "/api/career/view",
  GET_CAREER_DETAILS: "/api/career/details",
  UPDATE_CAREER: "/api/career/update",
  DELETE_CAREER: "/api/career/delete",
  TOGGLE_CAREER_ACTIVE_STATUS: "/api/career/toggle-active-status",
  TOGGLE_CAREER_FEATURED_STATUS: "/api/career/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_CAREERS: "/api/client/career/list",

  // NOTE Services::
  // <> ADMIN <>
  CREATE_NEW_SERVICE: "/api/service/create",
  GET_ALL_SERVICES: "/api/service/view",
  GET_SERVICE_DETAILS: "/api/service/details",
  UPDATE_SERVICE: "/api/service/update",
  DELETE_SERVICE: "/api/service/delete",
  TOGGLE_SERVICE_ACTIVE_STATUS: "/api/service/toggle-active-status",
  TOGGLE_SERVICE_FEATURED_STATUS: "/api/service/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_SERVICES: "/api/client/service/list",
  GET_PUBLIC_SERVICE_DETAILS: "/api/client/service/details",

  // NOTE Investments::
  // <> ADMIN <>
  CREATE_NEW_INVESTMENT: "/api/investment/create",
  GET_ALL_INVESTMENTS: "/api/investment/view",
  GET_INVESTMENT_DETAILS: "/api/investment/details",
  UPDATE_INVESTMENT: "/api/investment/update",
  DELETE_INVESTMENT: "/api/investment/delete",
  TOGGLE_INVESTMENT_ACTIVE_STATUS: "/api/investment/toggle-active-status",
  TOGGLE_INVESTMENT_FEATURED_STATUS: "/api/investment/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_INVESTMENTS: "/api/client/investment/list",
  GET_PUBLIC_INVESTMENT_DETAILS: "/api/client/investment/details",

  // NOTE Courses::
  // <> ADMIN <>
  CREATE_NEW_COURSE: "/api/courses/create",
  GET_ALL_COURSES: "/api/courses/view",
  GET_COURSE_DETAILS: "/api/courses/details",
  UPDATE_COURSE: "/api/courses/update",
  DELETE_COURSE: "/api/courses/delete",
  TOGGLE_COURSE_ACTIVE_STATUS: "/api/courses/toggle-active-status",
  TOGGLE_COURSE_FEATURED_STATUS: "/api/courses/toggle-featured-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_COURSES: "/api/client/courses/list",
  GET_PUBLIC_COURSE_DETAILS: "/api/client/courses/details",

  // NOTE Course Packages
  CREATE_NEW_COURSE_PACKAGE: "/api/courses/packages/create",
  GET_ALL_COURSE_PACKAGES: "/api/courses/packages/view",
  GET_COURSE_PACKAGE_DETAILS: "/api/courses/packages/details",
  UPDATE_COURSE_PACKAGE: "/api/courses/packages/update",
  DELETE_COURSE_PACKAGE: "/api/courses/packages/delete",
  TOGGLE_COURSE_PACKAGE_ACTIVE_STATUS:
    "/api/courses/packages/toggle-active-status",
  TOGGLE_COURSE_PACKAGE_FEATURED_STATUS:
    "/api/courses/packages/toggle-featured-status",

  // NOTE File::
  // <> ADMIN <>
  LOCAL_FILE_UPLOAD: "/api/file/upload",
  STORE_NEW_FILES: "/api/file/create",
  GET_ALL_FILES: "/api/file/view",
  DOWNLOAD_FILE: "/api/file/download",
  DELETE_FILE: "/api/file/delete",
  TOGGEL_FILE_DEFAULT_STATUS: "/api/file/toggle-default-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_FILES: "/api/client/files/list",

  // NOTE Menu::
  // <> ADMIN <>
  STORE_NEW_MENU: "/api/menu/create",
  GET_ALL_MENUS: "/api/menu/view",
  UPDATE_MENU: "/api/menu/update",
  DELETE_MENU: "/api/menu/delete",
  MENU_DETAILS: "/api/menu/details",
  TOGGLE_MENU_PRODUCT_STATUS: "/api/menu/toggle-product-status",
  TOGGLE_MENU_ACTIVE_STATUS: "/api/menu/toggle-active-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_MENUS: "/api/client/header-menu/list",

  // NOTE Page CMS::
  // <> ADMIN <>
  CREATE_NEW_PAGE_CMS: "/api/page-cms/create",
  GET_ALL_PAGE_CMS: "/api/page-cms/view",
  GET_PAGE_CMS_DETAILS: "/api/page-cms/details",
  GET_PAGE_CMS_CONTENT_DETAILS: "/api/page-cms/details/content",
  UPDATE_PAGE_CMS: "/api/page-cms/update",
  UPDATE_PAGE_CMS_CONTENT: "/api/page-cms/update/content",
  TOGGLE_PAGE_CMS_ACTIVE_STATUS: "/api/page-cms/toggle-active-status",
  // <> PUBLIC <>
  GET_PUBLIC_PAGE_CMS_CONTENT: "/api/client/page-cms/details/content",

  // NOTE Users::
  GET_ALL_USERS: "/api/user/get-all-users",
  GET_USER_DETAILS: "/api/user/get-user-details",
  DELETE_USER: "/api/user/delete-user",
  CREATE_ADMIN_STAFF: "/api/user/create-admin-staff",
  UPDATE_USER: "/api/user/update",

  // NOTE Users Roles::
  CREATE_ROLE: "/api/user/role/create",
  GET_ALL_ROLES: "/api/user/role/lists",
  GET_ROLE_DETAILS: "/api/user/role/details",
  UPDATE_ROLE: "/api/user/role/update",
  DELETE_ROLE: "/api/user/role/delete",

  // NOTE Users Permissions::
  GET_ALL_PERMISSIONS: "/api/user/permission/lists",

  // NOTE Languages::
  // <> ADMIN <>
  GET_ALL_LANGUAGES: "/api/language/lists",
  CREATE_LANGUAGE: "/api/language/create",
  LANGUAGE_DETAILS: "/api/language/details",
  UPDATE_LANGUAGE: "/api/language/update",
  DELETE_LANGUAGE: "/api/language/delete",
  TOGGLE_ACTIVE_LANGUAGE: "/api/language/toggle-active-status",
  TOGGLE_RTL_LANGUAGE: "/api/language/toggle-rtl-status",
  TOGGLE_DEFAULT_LANGUAGE: "/api/language/toggle-default-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_LANGUAGES: "/api/client/language/list",

  // NOTE Website Setting::
  // <> ADMIN <>
  UPDATE_WEBSITE_SETTINGS: "/api/website-settings/update",
  GET_ALL_WEBSITE_SETTINGS: "/api/website-settings/lists",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_WEBSITE_SETTINGS: "/api/client/website-settings/list",

  // NOTE Timezone::
  TIMEZONE_LISTS: "/api/timezone/lists",

  // NOTE Consult Enquiry Form::
  // <> PUBLIC <>
  SUBMIT_CONSULT_ENQUIRY_FORM: "/api/client/query/consult-enquiry",
  SUBMIT_GENERAL_ENQUIRY_FORM: "/api/client/query/general-enquiry",
  SUBMIT_BUSINESS_CLUB_RESERVATION_FORM:
    "/api/client/query/business-club-reservation",
  SUBMIT_CAREER_ENQUIRY_FORM: "/api/client/query/career-enquiry",
  SUBMIT_PARTNERSHIP_ENQUIRY_FORM: "/api/client/query/partnership-enquiry",
  SUBMIT_SERVICE_ENQUIRY_FORM: "/api/client/query/service-enquiry",
  SUBMIT_BUSINESS_ENQUIRY_FORM: "/api/client/query/business-enquiry",
  // <> ADMIN <>
  GET_ALL_CONSULTING_INQUIRIES: "/api/inquires/consulting/view",
  GET_ALL_GENERAL_INQUIRIES: "/api/inquires/general/view",
  GET_ALL_BUSINESS_INQUIRIES: "/api/inquires/business/view",
  GET_ALL_SERVICE_INQUIRIES: "/api/inquires/service/view",
  GET_ALL_BUSINESS_CLUB_INQUIRIES: "/api/inquires/business-club/view",
  GET_ALL_CAREER_INQUIRIES: "/api/inquires/career/view",
  GET_ALL_PARTNERSHIP_INQUIRIES: "/api/inquires/partnership/view",

  // NOTE Activity Log::
  GET_LATEST_ACTIVITY_TIME: "/api/client/content-update-date-time",

  // NOTE Notification::
  // <> ADMIN <>
  CREATE_NEW_NOTIFICATION: "/api/notification/create",
  GET_ALL_NOTIFICATIONS: "/api/notification/view",
  GET_NOTIFICATION_DETAILS: "/api/notification/details",
  UPDATE_NOTIFICATION: "/api/notification/update",
  DELETE_NOTIFICATION: "/api/notification/delete",
  TOGGLE_NOTIFICATION_ACTIVE_STATUS: "/api/notification/toggle-active-status",
  // <> PUBLIC <>
  GET_ALL_PUBLIC_NOTIFICATIONS: "/api/client/notification/view",

  // NOTE INSTA POSTS::
  GET_ALL_INSTA_POSTS: "/api/client/insta-posts",
};

export { API_ENDPOINTS };
